module.exports = __webpack_public_path__ + "static/media/SachinJain.3a187238.jfif";